export default __webpack_public_path__ + "assets/4f15f23d6e7b50d418826a1879cf0f02.svg";